export class SearchSynonymsModel {
  representationItemCategorisationId: number;
  reasonName: string;
  synonyms: string[];
}
